module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block col-sm-6 col-lg-4 col-xs-12"
  }, [(_vm.openenbinnenmv == 'true') ? _c('div', [_c('form', {
    attrs: {
      "action": _vm.ctx + '/verzekeringaanvragen.html',
      "method": "post"
    }
  }, [_c('button', {
    staticClass: "btn-invisible",
    attrs: {
      "type": "submit"
    }
  }, [_c('div', {
    staticClass: "card insurance"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.produktnaam))]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "icon icon-seven5"
  }, [_c('span', {
    class: 'icon-' + _vm.produkttypenaam
  })])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": _vm.csrftokenname
    },
    domProps: {
      "value": _vm.csrftokenvalue
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "anvaonlineIframeUrl"
    },
    domProps: {
      "value": _vm.produkturl
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Aanvragen")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.openenbinnenmv == 'false') ? _c('div', [_c('a', {
    staticClass: "btn-invisible",
    attrs: {
      "href": _vm.produkturl,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "card insurance"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h3', [_vm._v(_vm._s(_vm.produktnaam))]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "icon icon-seven5"
  }, [_c('span', {
    class: 'icon-' + _vm.produkttypenaam
  })])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "href": _vm.produkturl,
      "target": "_blank"
    }
  }, [_vm._v("Aanvragen")])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-679a07d2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/produkt.vue
// module id = 29
// module chunks = 0